<!-- hidden label to calculate if there is a label or not -->
<app-label-inflator #labelCalculator hidden [labelComponentInterface]="data"></app-label-inflator>
<div class="card-content" [style.gap.rem]="viewModel.sidebarAndContentGapInRem$ | async">
  <app-stiiizy-address-side-bar
    *ngIf="viewModel.showSidebar$ | async"
    [cardData]="data"
    [maxWidthInPx]="112"
    [maxHeightInPx]="11">
  </app-stiiizy-address-side-bar>
  <app-stiiizy-address-product-information [cardData]="data"></app-stiiizy-address-product-information>
</div>
